import { render } from "./SkeletonParagraph.vue?vue&type=template&id=663c7669"
import script from "./SkeletonParagraph.vue?vue&type=script&lang=js"
export * from "./SkeletonParagraph.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__